import http from "./http";
import Service from "../Service";
/**
 * @type ProviderService
 */
export default class RequestService extends Service {
    /**
     * Monitor de cotações do cliente (GET /clients/requests): page, page_size,
     * request_id, store, sent_by, status ou statuses[], identifier.
     */
    list(params = {}) {
        return http.get(`clients/requests`, {
            headers: this.getHeaders(),
            params,
        });
    }

    load_obs(request_id, store_id) {
        return http.get(`clients/requests/obs`, {
            headers: this.getHeaders(),
            params: {
                store_id,
                request_id,
            },
        });
    }

    send_temps(data) {
		return http.post("clients/requests/temporaries", data, {
			headers: this.getHeaders(),
            timeout: 90000
		});
	}

    save_obs(data) {
        return http.post(`clients/requests/obs`, data, {
            headers: this.getHeaders(),
        });
    }

    update_resupply_title(id, title) {
        return http.patch(`clients/requests/${id}/title`, { title }, {
            headers: this.getHeaders(),
        });
    }

    extract_resupply(id, data) {
        return http.post(`clients/requests/${id}/extract`, data, {
            headers: this.getHeaders(),
        });
    }

    request_offers(id, seller_id) {
        return http.get(`/clients/requests/${id}/sellers/${seller_id}/offers`, {
            headers: this.getHeaders(),
        });
    }

    request_offers_by_product(id, product_id) {
        return http.get(
            `/clients/requests/${id}/products/${product_id}/offers`,
            {
                headers: this.getHeaders(),
            }
        );
    }

    request_offers_by_product_per_store(id, product_id) {
        return http.get(
            `/clients/requests/${id}/products/${product_id}/offers/by-store`,
            {
                headers: this.getHeaders(),
            }
        );
    }

    general_request_report(id) {
        return http.get(`/clients/reports/requests/${id}/products`, {
            headers: this.getHeaders(),
        });
    }

    download_comparativo_pdf(id) {
        return http.get(`/clients/reports/requests/${id}/products`, {
            headers: this.getHeaders(),
            params: { export: "pdf" },
            responseType: "blob",
        });
    }

    full_general_request_report(id, seller_id) {
        return http.get(`/clients/reports/requests/${id}/products/all`, {
            headers: this.getHeaders(),
            params: seller_id ? { seller_id } : undefined,
        });
    }

    export_store_report(id, store_id, params) {
        return http.get(
            `/clients/reports/excel/requests/${id}/store/${store_id}`,
            {
                params,
                headers: this.getHeaders(),
                responseType: "arraybuffer",
            }
        );
    }
    uploadExcel (id, store_id, file) {
        var formData = new FormData();
        formData.append("file", file);
        return http.post( `clients/read/file/response/cot/${id}/loja/${store_id}`, formData, {headers: this.getHeaders(), 'Content-Type': 'multipart/form-data;', responseType: 'blob'})
    }

    sync(id) {
        return http.get(`/v2/clients/requests/${id}/sync`, {
            headers: this.getHeaders(),
            timeout: 40000
        });
    }

    load(id) {
        return http.get(`/v2/clients/requests/${id}`, {
            headers: this.getHeaders(),
        });
    }

    generate_orders(id, keys = []) {
        return http.post(`/v2/clients/requests/${id}/generate-orders`, { keys }, {
            headers: this.getHeaders(),
            timeout: 300000,
        });
    }

    /**
     * Pedido parcial (CLUB-1443, recurso requests.partial_orders). Gera
     * pedidos novos só com as linhas vencedoras ainda não pedidas.
     * payload: { keep_open, store_id?, seller_ids?, keys? }. Responde
     * { orders, cot_status } — 16 com a digitação aberta, 4 se fechou.
     */
    partial_orders(id, payload) {
        return http.post(`/v2/clients/requests/${id}/partial-orders`, payload, {
            headers: this.getHeaders(),
            timeout: 300000,
        });
    }

    /** Encerra a digitação de uma cotação em PEDIDO PARCIAL (vira 4). */
    close_partial_orders(id) {
        return http.post(`/v2/clients/requests/${id}/partial-orders/close`, {}, {
            headers: this.getHeaders(),
        });
    }

    /** Linha do monitor de uma cotação (GET /clients/requests/{id}), com status.id. */
    monitor_show(id) {
        return http.get(`clients/requests/${id}`, {
            headers: this.getHeaders(),
        });
    }

    reset(id) {
        return http.put(
            `/v2/clients/requests/${id}/reset`,
            {},
            {
                headers: this.getHeaders(),
            }
        );
    }

    toggle(data) {
        return http.post(`/v2/clients/requests/pre-orders/toggle`, data, {
            headers: this.getHeaders(),
        });
    }
    resyncOrder(id){
        return http.delete(`clients/external/data/${id}/integration`, {
            headers: this.getHeaders(),
        });
    }
    resyncOrders(orderIds){
        return http.delete(`clients/external/data/integration`, {
            headers: this.getHeaders(),
            data: { data_ids: orderIds },
        });
    }
    ExportOrder(id){
        return http.get(`clients/export/csv/cotacao/${id}`, {
            headers: this.getHeaders(),
        });
    }
    request_products(id, params) {
		return http.get(`/providers/requests/${id}/products`, {
            headers: this.getHeaders(),
            timeout: 20000,
            params: params
        });
	}
    last_offers(id, params) {
        return http.get(`clients/requests/${id}/products/provider/last`, {
            headers: this.getHeaders(),
            params
        });
    }
    createDiagnosisRequest(data) {
        return http.post('/clients/requests', data, {
            headers: this.getHeaders(),
        });
    }
    getRequestCompetitors(id, params = {}) {
        return http.get(`clients/requests/${id}/competitors`, {
            params,
            headers: this.getHeaders(),
        });
    }
    getRequestCompetitorsSummary(id, params = {}) {
        return http.get(`clients/requests/${id}/competitors/summary`, {
            params,
            headers: this.getHeaders(),
        });
    }
    exportRequestCompetitors(id, type, params = {}) {
    return http.get(`clients/requests/${id}/competitors`, {
        params: {
            export: type,
            ...params,
        },
        responseType: "blob",
        headers: this.getHeaders(),
    });
}

    /**
     * Pending pré-pedidos for one cotação: { pre_orders: [], meta: {} }.
     *
     * One row per (loja, vendedor, fornecedor) — a seller quoting under two
     * providers yields two rows, which is what the "Por fornecedor" view groups
     * by anyway. Returns ONLY pending rows: anything already ordered is filtered
     * out server-side, so there is no possuiPedido flag to check here.
     *
     * Replaces the legacy getLojasFornecedores, which needed a 20-minute timeout.
     */
    pre_orders(id) {
        return http.get(`clients/requests/${id}/pre-orders`, {
            headers: this.getHeaders(),
        });
    }

    pre_orders_products(id, { store_id, provider_id, seller_id }) {
        return http.get(`clients/requests/${id}/pre-orders/products`, {
            headers: this.getHeaders(),
            params: { store_id, provider_id, seller_id },
        });
    }

    /**
     * Flat, request-wide version of pre_orders_products() — one row per
     * (loja, fornecedor, vendedor, produto), same pending/non-generic rules
     * as pre_orders()/pre_orders_products(). Backs the winners-v2
     * pré-pedidos table views (Matriz, Por Produto, Analítico), replacing
     * general_request_report() there.
     *
     * Pass includeOrdered=true (used by the Produtos tab) to also get
     * already-ordered rows back, each carrying is_purchased — the other
     * pré-pedidos views must leave this off, since they expect pending-only
     * rows.
     */
    /**
     * Comparativo de preços paginado: { data: [produto + offers[]], meta }.
     *
     * Cada oferta traz quantity_to_buy (soma do vendedor em todas as lojas, ou
     * só na loja do filtro `store`), is_winner_in_scope e has_order (pedido
     * deste produto com este vendedor). Substitui o legado
     * request_products_with_offers, que pegava a quantidade de uma loja só.
     */
    comparison(id, params, token = null) {
        return http.get(`clients/requests/${id}/comparison`, {
            headers: this.getHeaders(),
            params,
            cancelToken: token,
        });
    }

    /**
     * Atualiza estoque e preço da última compra dos itens da cotação com os
     * dados do ERP (kyojin -> mirai). O mirai pode sincronizar o diagnóstico
     * antes de responder, por isso o timeout maior que o padrão do http.
     */
    refresh_erp_data(id, items = null) {
        return http.post(`clients/requests/${id}/erp-refresh`, items ? { items } : {}, {
            headers: this.getHeaders(),
            timeout: 240000,
        });
    }

    pre_orders_report(id, includeOrdered) {
        return http.get(`clients/requests/${id}/pre-orders/report`, {
            headers: this.getHeaders(),
            params: includeOrdered ? { include_ordered: 1 } : undefined,
        });
    }

    /**
     * Resupply (ressuprimento) origin of each per-store solicitação under
     * this cotação, when one exists — not every store will have one, see
     * RequestResupplyOrigin (kyojin) for why.
     */
    resupply_origins(id) {
        return http.get(`clients/requests/${id}/resupply`, {
            headers: this.getHeaders(),
        });
    }

    /**
     * Replica subrequisições desta cotação como novas solicitações "enviadas
     * para a central" — mesma lógica de CotacaoController@replicateRequest
     * (api legada), já portada para o kyojin com transação e sem o bug do
     * dispositivo_origem_id nulo. Sem `subrequestIds`, replica todas as
     * subrequisições da cotação; com a lista, replica só essas. Sem
     * `productIds`, cada nova solicitação leva todos os itens da
     * subrequisição; com a lista, leva só os itens desses produtos (uma
     * subrequisição sem nenhum deles não gera solicitação nova).
     */
    replicate(id, subrequestIds = null, productIds = null) {
        return http.post(
            `clients/requests/${id}/replicate`,
            { subrequest_ids: subrequestIds, product_ids: productIds },
            { headers: this.getHeaders() }
        );
    }
}
